module.exports = __webpack_public_path__ + "7ea1a33026bf62e356a0f8e0368cdc3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/TStorageWhite.jpg
// module id = 1291
// module chunks = 0